/* This example requires Tailwind CSS v2.0+ */
import {Fragment} from 'react'
import {Listbox, Transition} from '@headlessui/react'
import {ChevronDownIcon} from '@heroicons/react/outline'
import {ErrorMessage, useField} from "formik";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function Select(
    {
        field,
        form,
        ...props
    }
) {
    const options = props.options;
    const [fieldData, meta, helpers] = useField(field.name);
    const onChange = (selectedOption) => {
        helpers.setTouched(true);
        helpers.setValue(selectedOption.id);
        props.onChange && props.onChange(selectedOption.id);
    }


    return (
        <Listbox value={field.value} onChange={onChange}>
            {({open}) => (
                <div className="mt-1 relative">
                    <Listbox.Button className={classNames(
                        open ? 'rounded-t-lg' : 'rounded-lg',
                        form?.errors[field.name] && form?.touched[field.name] ? 'border-red-300' : 'border-gray-300',
                        'relative w-full bg-white border shadow-sm pr-4 px-4 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 sm:text-sm'
                    )}>
                        <Listbox.Label className="block bg-white text-xs text-gray-500">{props.label}</Listbox.Label>
                        <span
                            className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-lg">{options.find(o => o.id === field.value)?.name || props.placeholder}</span>
                        <span className={classNames(
                            'absolute inset-y-2 right-2 flex items-center pointer-events-none w-12 justify-center border-l border-gray-300'
                        )}>
                        <ChevronDownIcon className={classNames(
                            open ? 'rotate-180' : '',
                            'transition h-5 w-5 text-gray-400'
                        )} aria-hidden="true"/>
                    </span>
                        <div
                            className="absolute transform translate-y-1/2 bg-white bottom-0 left-6 px-2 text-xs text-red-600">
                            <ErrorMessage name={field.name}/>
                        </div>
                        {/*{ !form.errors[field.name] && form.touched[field.name] && (<CheckIcon className="absolute top-0 right-[6.5rem] transform translate-y-1/2 h-8 w-8 text-green-500 opacity-50" aria-hidden="true" />)}*/}
                    </Listbox.Button>

                    <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100"
                                leaveTo="opacity-0">
                        <Listbox.Options
                            className="absolute border-l border-r border-b border-gray-300 z-20 w-full bg-white shadow-lg max-h-60 rounded-b-lg py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                            {options.map((option) => (
                                <Listbox.Option
                                    key={option.id}
                                    className={({active}) =>
                                        classNames(
                                            active ? 'bg-red-100' : 'text-gray-900',
                                            'cursor-default select-none relative py-2 pl-8 pr-4'
                                        )
                                    }
                                    value={option}
                                >
                                    {({selected, active}) => (
                                        <>
                    <span
                        className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate sm:text-lg')}>
                      {option.name}
                    </span>

                                            {/*                  {selected ? (*/}
                                            {/*                      <span*/}
                                            {/*                          className={classNames(*/}
                                            {/*                              active ? 'text-white' : 'text-indigo-600',*/}
                                            {/*                              'absolute inset-y-0 left-0 flex items-center pl-1.5'*/}
                                            {/*                          )}*/}
                                            {/*                      >*/}
                                            {/*  <CheckIcon className="h-5 w-5" aria-hidden="true" />*/}
                                            {/*</span>*/}
                                            {/*                  ) : null}*/}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            )}
        </Listbox>
    )
}
